<app-header page='followup'>Campaigns Follow-up</app-header>

<div class="container">
  <app-campaign-list></app-campaign-list>
</div>
